import { PayoutContentById, PayoutResponse, RequestPayout, PayoutsResponse } from "types/payouts/payoutTypes";
import { apiClient } from "../client";

export const fetchAllPayouts = async (): Promise<PayoutResponse> => {
    try {
        const response = await apiClient.get<PayoutResponse>(`/payoutmanagement/admin/payouts`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch all payouts:", error);
        throw error; // Rethrow the error for the calling function to handle it.
    }
}

export const fetchPayoutsById = async (id: string): Promise<PayoutContentById> => {
    try {
        const response = await apiClient.get<PayoutContentById>(`/payoutmanagement/admin/payouts/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch payout by ID:", error);
        throw error;
    }
}

export const updatePayout = async (payoutId: string, payload: RequestPayout): Promise<PayoutsResponse> => {
    try {
        const response = await apiClient.put<PayoutsResponse>(`/payoutmanagement/admin/payouts/${payoutId}/status`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Failed to update payout:", error);
        throw error;
    }
}
